import { render, staticRenderFns } from "./AppraisalSection.vue?vue&type=template&id=04aab80a&scoped=true"
import script from "./AppraisalSection.vue?vue&type=script&lang=ts"
export * from "./AppraisalSection.vue?vue&type=script&lang=ts"
import style0 from "./AppraisalSection.vue?vue&type=style&index=0&id=04aab80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aab80a",
  null
  
)

export default component.exports